<template>
  <v-menu
    v-if="$currentUser"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="white"
        icon
        v-on="on"
      >
        <v-avatar
          :size="44"
        >
          <img
            v-if="$currentUser.photoURL"
            :src="$currentUser.photoURL"
          >

          <span v-else-if="$currentUser.displayName">
            {{ $currentUser.displayName.split(' ').slice(0, 2).map(x => x[0]).join('') }}
          </span>

          <span
            v-else
            style="font-size:1.4rem"
          >
            🧑
          </span>
        </v-avatar>
      </v-btn>
    </template>
    <v-list>
      <v-list-item @click="signOut">
        <v-list-item-title>Sign Out</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>

  <dialog-login v-else />
</template>

<script>
import * as firebase from 'firebase/app'

import DialogLogin from '@/components/DialogLogin'

export default {
  components: {
    DialogLogin
  },
  methods: {
    async signOut () {
      try {
        await firebase.auth().signOut()
        window.location.href = '/'
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style>

</style>
